module.exports = __webpack_public_path__ + "static/media/SmartIot_Vertical_App.26ebac0f.png";